import React from 'react';
import { PageContainer } from './styled/layout';
import { Box, Flex } from 'rebass';
import { TopBar } from '../components/TopBar';
import { SideBar, COLLAPSED_WIDTH } from '../components/SideBar';
import features from '../features';

const Layout: React.FC = ({ children }) => {
  const enabledFeatures = features();
  const showSideBar =
    enabledFeatures.referral && enabledFeatures.serviceDelivery;
  return (
    <>
      <TopBar />
      {showSideBar && <SideBar />}
      <Flex>
        <Box ml={showSideBar ? COLLAPSED_WIDTH : 0} width="100%">
          <PageContainer>{children}</PageContainer>
        </Box>
      </Flex>
    </>
  );
};
export { Layout };
